/** @jsx jsx */
import React, { useRef } from 'react';
import { css, jsx } from '@compiled/react';
import throttle from 'lodash/throttle';
import { WidthObserver } from '@atlaskit/width-detector';
import { ConsentBanner } from '@atlassian/browser-storage-controls';
import { MIN_BANNER_WIDTH } from '../../constants';
import {
	useCookieConsentBannerSettings,
	useCookieConsentBannerSettingsActions,
} from '../../services/preferences';

export const CookieConsentBanner = () => {
	const [{ height }] = useCookieConsentBannerSettings();
	const { onDismiss, setHeight } = useCookieConsentBannerSettingsActions();
	const ref = useRef<HTMLDivElement>(null);

	const setWidth = () => {
		ref.current && setHeight(ref.current.clientHeight);
	};

	const throttledSetWidth = throttle(setWidth, 50);

	return (
		<>
			<WidthObserver setWidth={throttledSetWidth} />
			<div
				ref={ref} // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
				css={css({
					...(!height && {
						visibility: 'hidden',
					}),
				})}
			>
				<ConsentBanner onHide={onDismiss} minWidth={MIN_BANNER_WIDTH} product="Jira" />
			</div>
		</>
	);
};
